export default "__VITE_ASSET__B481N39___"